<div class="d-flex flex-row align-items-center justify-content-center">
  <label>{{ beneficiary }}</label>
</div>
